<mat-vertical-stepper linear [selectedIndex]="selectedStepIndex"
  *ngIf="{ vehicleDropdowns: vehicleDropdowns$ | async, associateDropdowns: associateDropdowns$ | async, addressDropdowns: addressDropdowns$ | async} as data;">
  <mat-step [stepControl]="vehicleForm">
    <form fxLayout="row wrap" fxLayoutAlign="start center" [formGroup]="vehicleForm" novalidate>
      <ng-template matStepLabel>Vehicle</ng-template>
      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Vin</mat-label>
          <input id="vehicleFormVin" matInput formControlName="vin" oninput="this.value = this.value.toUpperCase()">
          <mat-error *ngIf="vehicleForm.get('vin').errors">
            {{vehicleForm.get('vin').errors | inputError}}
          </mat-error>
          <mat-hint [ngSwitch]="vinError">
            <span *ngSwitchCase="'vinCheckDigitFailed'">Vin does not pass Check Digit validation and may be
              invalid.</span>
            <span *ngSwitchCase="'vinLengthFailed'">Vin is less than 17 characters and may be invalid.</span>
          </mat-hint>
        </mat-form-field>
      </div>
      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Trim</mat-label>
          <mat-select formControlName="trimLevel">
            <mat-option *ngFor="let trim of trims" [value]="trim.trim">
              {{trim.trim}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Sub-Type</mat-label>
          <mat-select formControlName="subTypeId">
            <mat-option *ngFor="let subType of data.vehicleDropdowns.subTypes" [value]="subType.id"
              (click)="setVehicleType(subType)">
              {{subType.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Year</mat-label>
          <input id="year" type="number" matInput formControlName="year">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Make</mat-label>
          <mat-select formControlName="make">
            <mat-option *ngFor="let make of data.vehicleDropdowns.makes" [value]="make.description">
              {{make.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Model</mat-label>
          <input id="model" matInput formControlName="model">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Body</mat-label>
          <input #vehicleBody matInput autocomplete="vehicleBody" id="vehicleBody" aria-label="Body"
            [matAutocomplete]="vehicleBodyAuto" formControlName="body">
          <mat-autocomplete #vehicleBodyAuto="matAutocomplete" autocomplete="vehicleBody">
            <mat-option *ngFor="let body of bodyDropdowns$ | async" [value]="body.vehicleBody">
              <span>{{body.vehicleBody}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Engine</mat-label>
          <input id="engine" matInput formControlName="engine">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Plate Number</mat-label>
          <input id="licensePlateNumber" matInput formControlName="licensePlateNumber"
            oninput="this.value = this.value.toUpperCase()">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Current Mileage</mat-label>
          <input id="currentMileage" type="number" matInput formControlName="currentMileage">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>Prospect Colour</mat-label>
          <mat-select formControlName="prospectColourId">
            <mat-option *ngFor="let colour of data.vehicleDropdowns.colours" [value]="colour.id">
              {{colour.colourDescription}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
        <mat-form-field appearance="fill">
          <mat-label>In-Service Date</mat-label>
          <input formControlName="deliveryDate" matInput [matDatepicker]="picker" [max]="maxInServiceDate">
          <mat-error *ngIf="vehicleForm.get('deliveryDate').errors">
            {{vehicleForm.get('deliveryDate').errors | inputError}}
          </mat-error>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="button-div" fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
        <button mat-button color="primary" [disabled]="vehicleForm.invalid" matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="associateForm">
    <form fxLayout="row wrap" fxLayoutAlign="start center" autocomplete="dank" [formGroup]="associateForm">
      <ng-template matStepLabel>Associate</ng-template>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Name (Last, First)</mat-label>
          <input #associateName matInput autocomplete="dank" id="dank" aria-label="Associate" [matAutocomplete]="auto"
            formControlName="name" (keyup)="associateName.value=makeUpperCase(associateName.value)">
          <mat-autocomplete #auto="matAutocomplete" autocomplete="dank"
            [displayWith]="displayAssociateName.bind(auto,filteredAssociates)"
            (optionSelected)="selectAssociate($event.option.value,filteredAssociates)">
            <mat-option value="addAssociate">Add Associate</mat-option>
            <mat-option *ngFor="let associate of filteredAssociates" [value]="associate.id">
              <span>{{associate.nameAddress}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input id="emailAddress" matInput formControlName="emailAddress">
          <mat-error *ngIf="associateForm.get('emailAddress').errors">
            {{associateForm.get('emailAddress').errors | inputError}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Message Preference</mat-label>
          <mat-select name="messagePreferenceId" formControlName="messagePreferenceId">
            <mat-option *ngFor="let messageType of data.associateDropdowns.messageTypes" [value]="messageType.id">
              {{messageType.description}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <form id="addressForm" fxLayout="row wrap" fxLayoutAlign="start center" [formGroup]="addressForm" novalidate>
      <div class="form-field" fxLayoutAlign="center center" fxFlex="66" fxFlex.xs="100">
        <mat-form-field appearance="fill" class="w-95">
          <mat-label>Address Line</mat-label>
          <input #addressLine1 id="addressLine1" matInput formControlName="addressLine1" [matAutocomplete]="addressAuto"
            autocomplete="addressAuto">
          <mat-autocomplete #addressAuto="matAutocomplete" autocomplete="addressAuto"
            (optionSelected)="selectAddress($event.option.value, data.addressDropdowns)">
            <mat-option *ngFor="let address of addressPredictions" [value]="address">
              <span>{{address.description}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Province/State</mat-label>
          <mat-select name="provStateId" formControlName="provStateId">
            <mat-option *ngFor="let provinceState of data.addressDropdowns.provinceStates" [value]="provinceState.id">
              {{ provinceState.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Location</mat-label>
          <input #locationName matInput autocomplete="locationAuto" id="locationAuto" aria-label="Location"
            [matAutocomplete]="locationAuto" formControlName="locationId">
          <mat-autocomplete #locationAuto="matAutocomplete" autocomplete="locationAuto"
            [displayWith]="displayLocationName">

            <mat-option *ngFor="let location of filteredLocations$ | async" [value]="location"
              (click)="setPostalCodeAndProvince(location)">
              <span>{{location.description}} {{location.provStateId}}, {{location.countryId}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Postal/Zip Code</mat-label>
          <input id="postalZipCode" matInput formControlName="postalZipCode">
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Cell Phone #</mat-label>
          <input id="cellPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
            formControlName="cellPhoneNumber">
          <mat-error *ngIf="addressForm.get('cellPhoneNumber').errors">
            {{addressForm.get('cellPhoneNumber').errors | inputError}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33">
        <mat-form-field appearance="fill">
          <mat-label>Home Phone #</mat-label>
          <input id="homePhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
            formControlName="homePhoneNumber">
        </mat-form-field>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
        <button mat-button matStepperPrevious>Back</button>
        <button [disabled]="!createReady" mat-button color="primary"
          (click)="createVehicle(associateForm.getRawValue(),addressForm.getRawValue(), vehicleForm.getRawValue())"
          matStepperNext>Create</button>
      </div>
    </form>
  </mat-step>
</mat-vertical-stepper>
